import jwtDecode from "jwt-decode";

import { SET_USER, UNSET_USER } from "./types";

const initialState = {
    isAuth: false,
    user: {},
};

const userReducer = (state = initialState, action) => {
    let decoded;

    switch (action.type) {
        case SET_USER:
            if (action.payload) {
                decoded = jwtDecode(action.payload);
            }
            localStorage.setItem("TOKEN", action.payload);
            return {
                ...state,
                isAuth: true,
                user: decoded,
            };

        case UNSET_USER:
            localStorage.removeItem("TOKEN");

            return {
                ...state,
                isAuth: false,
                user: {},
            };

        default:
            return state;
    }
};

export default userReducer;